import { useEffect } from 'react';

const CognitoSecurityLoader = ({ children }) => {
    useEffect(() => {
        // Need to check if it already exists to prevent the "already registered" error
        if (!document.querySelector('script[src*="amazon-cognito-advanced-security-data.min.js"]')) {
            const script = document.createElement("script");
            script.src = "https://amazon-cognito-assets.us-west-2.amazoncognito.com/amazon-cognito-advanced-security-data.min.js";
            script.async = false;
            document.body.appendChild(script);
        }
    }, []);

    return <>{children}</>;
};

export default CognitoSecurityLoader;